import { near, far } from "./Background"

export class Paralax {
  constructor() {
    this.far = far
    this.near = near
  }

  speed = 0
  speedLimit = 0

  addParalax = (stage) => {
    stage.addChild(this.far)
    stage.addChild(this.near)
  }

  setSpeed = (s) => (this.speedLimit = s)

  sizeUpdater = (w, h) => {
    this.near.width = w
    this.near.height = h
    this.far.width = w
    this.far.height = h
  }

  paralaxUpdater = () => {
    if (this.speed > this.speedLimit) {
      this.speed--
    }
    if (this.speed < this.speedLimit) {
      this.speed++
    }
    this.near.tilePosition.y += this.speed / 10
    this.far.tilePosition.y += this.speed / 20

    if (this.near.tilePosition.y >= 2668) {
      this.near.tilePosition.y = 0
    }

    if (this.far.tilePosition.y >= 689) {
      this.far.tilePosition.y = 0
    }
  }
}
